import { Action } from "@ngrx/store";
import { IUser } from "../interfaces/ilogin";
import { IBusinessFunction } from "../interfaces/ibusinessfunction";

export const actionTypes: any = {
    SET_USER_DETAILS: "Setting user details",
    SET_SELECTED_BUSINESS_FUNCTION: "Setting selected business function",
    CLEAR_USER_DETAILS: "Clears user details",
    CLEAR_SELECTED_BUSINESS_FUNCTION: "Clear selected business function",
    ADD_BUSINESS_FUNCTION: "Add new business function"
};

export class SetUserDetailsAction implements Action {
    type = actionTypes.SET_USER_DETAILS;

    constructor(public payload: IUser) { }
}

export class SetSelectedBusinessFunctionAction implements Action {
    type = actionTypes.SET_SELECTED_BUSINESS_FUNCTION;
    constructor(public payload: IBusinessFunction) { }
}

export class AddBusinessFunctionAction implements Action {
    type = actionTypes.ADD_BUSINESS_FUNCTION;
    constructor(public payload: IBusinessFunction) { }
}

export class ClearUserDetailsAction implements Action {
    type = actionTypes.CLEAR_USER_DETAILS;
}

export class ClearSelectedBusinessFunctionAction implements Action {
    type = actionTypes.CLEAR_SELECTED_BUSINESS_FUNCTION;
}

export type Actions = SetUserDetailsAction
    | SetSelectedBusinessFunctionAction
    | ClearUserDetailsAction
    | ClearSelectedBusinessFunctionAction
    | AddBusinessFunctionAction;